export default __webpack_public_path__ + "img/sun-cloud-snow.c11a876.svg";